<div class="contents-field">
  <div class="contents-container">
    <div class="pt-3 pb-3">
      人事異動時などに権限を一括で変更することができます<br>
      ダウンロードファイルを開き、権限変更したい箇所を変更してください
    </div>
    <div class="py-3 download-field">
      <div>
        ファイルダウンロード：
      </div>
      <div style="margin-left: 0.5rem;">
        <button mat-raised-button color="primary">ダウンロード</button>
      </div>
    </div>
    <div class="upload-field">
      <div class="message-title">
        メッセージ
      </div>
      <div class="upload-control-filed">
        <app-message-field class="message-field"></app-message-field>
        <app-upload-file class="file-drop-field"></app-upload-file>
        <div class="upload-button">
          <button mat-raised-button>
            <i class="fa fa-upload"> アップロード</i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
